<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span class="ePub-I">PART I</span></p>
<p class="PEP">Americans were the first to understand that wealth has to be created. The words “to make money” hold the essence of human morality.</p>
<p class="PEPC"><span class="ePub-SC">—AYN RAND, </span><span class="ePub-SC-I">ATLAS SHRUGGED</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?895fdde8